import React, { FC } from 'react';
import { Package } from 'common/svg';
import { useAppSelector } from 'app/store/store.hooks';
import { IGoodRemain } from 'entities/Goods/Goods.models';
import { selectCurrentUser } from 'entities/User/User.slice';

interface IComponentProps {
  remains?: IGoodRemain[];
}

export const GoodInStock: FC<IComponentProps> = ({ remains = [] }) => {
  // user
  const currentUser = useAppSelector(selectCurrentUser);

  const city = currentUser?.city;

  if (!city) {
    return null;
  }

  // Для сателлита наличие считается по родительскому городу (там расположены склады).
  const effectiveCityName = city.parent?.name ?? city.name;

  const count = remains.reduce((acc, item) => {
    if (item.city === effectiveCityName) {
      acc += item.count ?? 0;
    }

    return acc;
  }, 0);

  return (
    <div className="flex align-center gap-3">
      <Package className="icon-package-dark-grey" />
      {count >= 1 ? (
        <span className="flex-1">
          <span className="ff-medium fs-s">{`${count} шт в наличии `}</span>
          <span className="ff-regular fs-s color-dark-grey"> в вашем городе</span>
        </span>
      ) : (
        <span className="ff-regular fs-s color-dark-grey">Нет в наличии в вашем городе</span>
      )}
    </div>
  );
};
